import React from 'react';
import { LinkOutlined } from '@ant-design/icons';
import { readExtractionRoutingMetadata } from './chatPanelExtractionRouting';
import styles from './ChatPanel.module.css';

export interface ChatPanelSystemMessageProps {
  text: string;
  metadata?: Record<string, unknown>;
}

export const ChatPanelSystemMessage: React.FC<ChatPanelSystemMessageProps> = ({ text, metadata }) => {
  const extraction = readExtractionRoutingMetadata(metadata);

  return (
    <div className={styles.systemMessage} data-testid="chat-system-message">
      <span className={styles.systemMessageLabel}>System</span>
      <p className={styles.systemMessageText}>{text}</p>
      {extraction?.artifact_item_ref ? (
        <p className={styles.systemMessageMeta}>
          <LinkOutlined aria-hidden />
          <span>Artifact: {extraction.artifact_item_ref}</span>
          {extraction.extraction_status ? (
            <span className={styles.systemMessageStatus}> · {extraction.extraction_status}</span>
          ) : null}
        </p>
      ) : extraction?.extraction_status ? (
        <p className={styles.systemMessageMeta}>Status: {extraction.extraction_status}</p>
      ) : null}
    </div>
  );
};
